import {
  skeleton_styles_default
} from "./chunk.5V5RNDE3.js";
import {
  o
} from "./chunk.ONXLNBOP.js";
import {
  e,
  n
} from "./chunk.5E26GMTR.js";
import {
  $,
  s4
} from "./chunk.3PRAXUFA.js";
import {
  __decorateClass
} from "./chunk.7RPYXGIF.js";

// node_modules/@shoelace-style/shoelace/dist/chunks/chunk.LFCTWBU7.js
var SlSkeleton = class extends s4 {
  constructor() {
    super(...arguments);
    this.effect = "none";
  }
  render() {
    return $`<div part="base" class=${o({
      skeleton: true,
      "skeleton--pulse": this.effect === "pulse",
      "skeleton--sheen": this.effect === "sheen"
    })} aria-busy="true" aria-live="polite" ><div part="indicator" class="skeleton__indicator"></div></div>`;
  }
};
SlSkeleton.styles = skeleton_styles_default;
__decorateClass([
  e()
], SlSkeleton.prototype, "effect", 2);
SlSkeleton = __decorateClass([
  n("sl-skeleton")
], SlSkeleton);

export {
  SlSkeleton
};
